import * as axios from "axios";
import DeviceDetector from "device-detector-js";
const getLocation = async function () {
  try {
    const getIp = await axios.default.get("https://api.ipify.org/?format=json");
    const ua = window.navigator.userAgent;
    const deviceDetector = new DeviceDetector();
    const device = deviceDetector.parse(ua);

    const geo = await axios.default.get(
      `https://api.ipapi.com/api/${getIp.data.ip}?access_key=${process.env.REACT_APP_IP_API_TOKEN}`
    );

    const data = {
      ip: getIp.data?.ip,
      sistemaOperacional: device.os?.name,
      sistemaOperacionalVersao: device.os?.version,
      browser: device.client?.name,
      tipoAcesso: device.device?.type,
      latitude: geo.data?.latitude,
      longitude: geo.data?.longitude,
      city: geo.data?.city,
      state: geo.data?.region_name,
      country: geo.data?.country_code,
    };
    return data;
  } catch {
    return false;
  }
};

export default getLocation;
